// @flow

import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export async function safetypayOnlineOutgoingPaymentMapper(): Promise<$Shape<OutgoingPayment>> {
  return {
    payment_type: 'safetypay-online',
    payment_type_code: 'safetypay-online',
    instalments: '1',
  };
}
